import FillModel from "./fill";
const MaskModels = {
  fill: FillModel
};
export default MaskModels;